import { isDesktop, isMobile, isTablet } from 'react-device-detect';
import LayoutMobile from './components/LayoutMobile';
import LayoutDesk from './components/LayoutDesk';
import LayoutTablet from './components/LayoutTablet';

// Corregí el uso de children: se usa {children} directamente en lugar de <Children/>
// porque children es un nodo React, no un componente.
export default function LayoutManager({children}) {

  const Children = children;

  if(isMobile){
    return (    
      <LayoutMobile>
        <Children/>
      </LayoutMobile>
    )
  }

  if(isTablet){
    return (
      <LayoutTablet>
        <Children/>
      </LayoutTablet>
    )
  }

  if(isDesktop){
    return (
      <LayoutDesk>
        <Children/>
      </LayoutDesk>
    )
  }

  return (    
    <LayoutDesk>
      <Children/>
    </LayoutDesk>
  )

}
